export const TOAST_TIME_IN_MS = 1200;
export const COLUMN_TITLES = [
  { id: 1, title: 'Approval Type', width: 3 },
  { id: 2, title: 'Company', width: 3 },
  { id: 3, title: 'Project Name', width: 3 },
  { id: 4, title: 'Launched On', width: 3 },
  { id: 5, title: '', width: 3 },
  { id: 6, title: '', width: 1 },
];
